import axios from 'axios';

export function postSalesforceOnboardingFormData(data: any) {
  // proxy request to api route to track logs in Vercel
  return axios.post('/api/forms/submitcase', data);
}
export function postSalesforceFormDataToEloqua(submitUrl: string, data: any) {
  return axios.post(submitUrl, data);
}
